export default {
  "content": "<g clip-path=\"url(#a)\" fill=\"#fff\"><path d=\"M16.737 6.985a2 2 0 00-2-2H13.07l-.614-1.263a1.331 1.331 0 00-1.192-.737H6.246c-.505 0-.967.285-1.193.737l-.65 1.263H2.738c-1.104 0-1.982.932-1.982 2.036v6.964a2 2 0 002 2h12a2 2 0 002-2l-.018-7zm-7.982 7a4 4 0 110-8 4 4 0 010 8z\"/><path d=\"M10.755 10.985a1 1 0 01-1-1c0-.551-.45-1-1-1a1 1 0 010-2c1.654 0 3 1.346 3 3a1 1 0 01-1 1z\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" transform=\"translate(.755 .985)\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "17",
    "height": "17",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};